import Lottie from 'lottie-react'
import './style.scss'
import { AppText, Button, CustomContainer, FlexColumn, GridContainer } from "src/style"
import successGif from "src/assets/gif/success.json";


const CbpAccountCreated = () => {
    return(
        <CustomContainer className='cbp-container'>
            <FlexColumn justifyContent='center'>
                    <GridContainer width="20" sizeUnit="">
                        <Lottie animationData={successGif} loop={true} />
                    </GridContainer>
                    <AppText 
                        textSize="2.2" fontWeight="700" fontFamily="Gilmer-Bold" 
                        align="center"
                    >
                        Account Created Successfully
                    </AppText>
                    <FlexColumn bgColor='#F9FAFB' height='30' justifyContent='flex-center' alignItems='flex-start' padding='3' radius='2'>
                        <AppText fontWeight='600' textSize='2'>
                            Account Details
                        </AppText>
                        <AppText fontWeight='40' textSize='2' topMargin='2' color='#667085'>
                            Account Name
                        </AppText>
                        <AppText fontWeight='400' textSize='2'>
                            Oluwatobi
                        </AppText>
                        <AppText fontWeight='40' textSize='2' topMargin='2' color='#667085'>
                            Account Number
                     </AppText>
                        <AppText fontWeight='600' textSize='2'>
                            0123456789
                        </AppText>

                    </FlexColumn>
                    </FlexColumn>
                    {/* <Button 
                        width='100%' topMargin='6' 
                        borderColor='#0D968F' hoverBgColor='#fff' 
                        hoverColor='#0D968F' titleSize="1.4"
                        // onClick={() => navigate('/login')}
                    >
                        Proceed to Dashboard
                    </Button> */}
        </CustomContainer>
    )
}

export default CbpAccountCreated